import request from '@/utils/request';
import type {
  Merchant,
  MerchantFormValues,
  MerchantOrderAssignWeight,
  MerchantReturnConfig,
  MerchantReturnConfigType
} from '@/types/merchant';
import type {PaginatedResponse} from '@/types/common';

export async function fetchMerchantList(params?: any): Promise<PaginatedResponse<Merchant>> {
  return request('/api/admin/merchants', { params });
}

export async function fetchMerchantDetail(id: number): Promise<Merchant> {
  return request(`/api/admin/merchants/${id}`);
}

export async function createMerchant(data: MerchantFormValues) {
  return request.post('/api/admin/merchants', data);
}

export async function updateMerchant(id: number, data: MerchantFormValues) {
  return request.put(`/api/admin/merchants/${id}`, data);
}

export async function deleteMerchant(id: number) {
  return request.delete(`/api/admin/merchants/${id}`);
}

export async function getAllMerchants(): Promise<{id: number, name: string, identity?: 'SUPPLIER' | 'SELF_OPERATED'}[]> {
  return request('/api/admin/merchants/all');
}

export async function getAuthUrl(id: number): Promise<string> {
  return await request.get(`/api/admin/merchants/get-auth-url/${id}`);
}

export async function getSignUrl(id: number): Promise<string> {
  return await request.get(`/api/admin/merchants/get-sign-url/${id}`);
}

export async function getMerchantOrderAssignWeight(id: number): Promise<MerchantOrderAssignWeight> {
  return request.get(`/api/admin/merchants/${id}/order-assign-weight`);
}

export async function updateMerchantOrderAssignWeight(
  id: number,
  orderAssignWeight: number
): Promise<MerchantOrderAssignWeight> {
  return request.put(`/api/admin/merchants/${id}/order-assign-weight`, { orderAssignWeight });
}

export async function getMerchantReturnConfig(id: number): Promise<MerchantReturnConfig> {
  return request.get(`/api/admin/merchants/${id}/return-config`);
}

export async function updateMerchantReturnConfig(
  id: number,
  returnConfig: MerchantReturnConfigType
): Promise<MerchantReturnConfig> {
  return request.put(`/api/admin/merchants/${id}/return-config`, { returnConfig });
}
